import React from 'react'
import styled from 'styled-components'

const GREEN = '#00552e'
const MUTED = '#4b5563'

const SectionHeading = styled.div`
  margin: 30px 0 20px;

  h2 {
    margin: 0 0 4px;
    font-size: 23px;
  }

  p {
    margin: 0;
    color: ${MUTED};
  }
`

const ResourceCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(250px, 1fr));
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const ResourceCard = styled.div`
  padding: 24px;
  border: 1px solid #d8dde1;
  border-radius: 12px;

  h3 {
    margin: 0 0 10px;
    color: ${GREEN};
  }

  p {
    margin: 0;
    line-height: 1.6;
    color: #30363d;
  }
`

const IPNResources = () => (
    <>
        <SectionHeading>
            <h2>IPN Resources</h2>
            <p>Additional resources and information for the IPN cohort</p>
        </SectionHeading>

        <ResourceCards>
            <ResourceCard>
                <h3>About the Study</h3>
                <p>
                    Put whatever text you want here.
                </p>
            </ResourceCard>

            <ResourceCard>
                <h3>Publications</h3>
                <p>
                    Publication information, citations, or links can go here.
                </p>
            </ResourceCard>

            <ResourceCard>
                <h3>External Resources</h3>
                <p>
                    dbGaP, SPARC, documentation, or other resources can go here.
                </p>
            </ResourceCard>
        </ResourceCards>
    </>
)

export default IPNResources